import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Box className="modern-footer">
      <Container>
        <Grid container spacing={4} justifyContent="space-between" alignItems="flex-start">
          
          {/* Logo + adresse */}
          <Grid item xs={12} md={3} className="footer-logo-block">
            <div className="footer-logo centered-logo">
              <img src="/images/footer/logo.png" alt="Logo Cooptaleo" />
            </div>
            <Typography variant="body2" className="footer-address centered-address">
              231 rue Saint-Honoré<br />
              75001 – PARIS<br />
              France
            </Typography>
          </Grid>

          {/* Liens utiles */}
          <Grid item xs={12} sm={4} md={3}>
            <Typography variant="subtitle1" className="footer-title">Informations utiles</Typography>
            <Link href="/cgu" className="footer-link">Conditions générales d'utilisation</Link><br />
            <Link href="/confidentiality" className="footer-link">Politique de confidentialité</Link><br />
            <Link href="/cookie-policy" className="footer-link">Politique de cookies</Link><br />
            <Link href="/legale" className="footer-link">Mentions légales</Link>
          </Grid>

          {/* Ressources */}
          <Grid item xs={12} sm={4} md={3}>
            <Typography variant="subtitle1" className="footer-title">Ressources</Typography>
            <Link href="/fiches" className="footer-link">Fiches métiers</Link><br />
            <Link href="/faq" className="footer-link">FAQ</Link>
          </Grid>

          {/* Réseaux sociaux */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" className="footer-title">Rejoignez le réseau</Typography>
            <Box className="footer-socials">
              <IconButton
                className="linkedin-link"
                href="https://www.linkedin.com/company/cooptaleo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/footer/linkedin.png" alt="LinkedIn" className="social-icon-img" />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box mt={5} textAlign="center" fontSize="14px" opacity={0.7}>
          © {currentYear} COOPTALEO. Tous droits réservés.
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
